import { useEffect } from "react";
import { useState } from "react";
import React from "react";
import { store } from "../../redux/store";

import DistrictTable from "./DistrictTable";

import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../redux/slices/deviceDistrictSlice";
import DistrictSearchBar from "./DistrictSearchBar";
const DistrictIndex = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [deleteDistrict, { isSuccess: deleteSuccess }] =
    store.useDeleteDistrictMutation();
  const [getDistricts] = store.useLazyGetDistrictsQuery();
  const deleteDistrictId = useSelector(
    (state) => state?.deviceDistrictSlice.deleteDistrictId
  );
  const params = {
    page: page,
    perPage: perPage,
  };
  useEffect(() => {
    getDistricts(params);
  }, [page]);
  useEffect(() => {
    if (deleteDistrictId) {
      deleteDistrict(deleteDistrictId);
      dispatch(actions.setDeleteDistrictId(null));
    }
  }, [deleteDistrictId]);
  useEffect(() => {
    if (deleteSuccess) {
      getDistricts(params);
    }
  }, [deleteSuccess]);
  return (
    <>
      <DistrictSearchBar params={params} />
      <DistrictTable perPage={perPage} page={page} setPage={setPage} />
    </>
  );
};
export default React.memo(DistrictIndex);
